<!-- src/components/StatisticsCard.vue -->
<template>
  <div 
    @click="data && data.length > 0 ? activePrompt = true : null"
    class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
    <statistics-card-line
      hideChart
      class="mb-base"
      :icon="icon"
      icon-right
      :statistic="statistic"
      :statisticTitle="statisticTitle"
      :color="color"
    />
    <vs-prompt :title="statisticTitle" class="export-options" @cancle="clearFields" @accept="exportToExcel(data)" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
        <vs-input v-model="fileName" placeholder="Enter File Name.."  class="w-full" /><br>
        <!-- <v-select :name="'selectFormat' + statisticTitle" v-model="selectedFormat" :options="formats" class="my-4" /> -->
        <div class="flex">
          <span class="mr-4">Cell Auto Width:</span>
          <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
        </div>
    </vs-prompt>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import axios from '../axios'

export default {
  components: {
    StatisticsCardLine
  },
  props: {
    statistic: {
      type: Number,
      required: true
    },
    statisticTitle: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'UserCheckIcon'
    },
    color: {
      type: String,
      default: 'success'
    },
    data: {
      type: Array,
      default: () => []
    },
    beforeDate: {
      type: String,
      default: ''
    },
    afterDate: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      activePrompt: false,
      fileName: `${this.beforeDate  }_${  this.afterDate  }_${  this.statisticTitle}`,
      selectedFormat: 'xlsx',
      cellAutoWidth: true,
      headerTitle: ['username', 'เบอร์โทรศัพท์', 'LINE'],
      headerVal: ['username',  'member_phone', 'member_line'],
      formats:['xlsx', 'csv', 'txt']
    }
  },
  methods: {
    async exportToExcel (sum_data) {
      await import('@/vendor/Export2Excel').then(excel => {
        const list = sum_data
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })

        // Log the export action
        this.logExportAction(sum_data)

        this.clearFields()
      })
    },
    async logExportAction (sum_data) {
      try {
        const objectLogs = {
          username: null,
          category: 'exportReport',
          type: 'activeUserReport',
          amount: sum_data.length || 0,
          info: `ดาวโหลด report ผู้ใช้งานแอคทีฟ: ${this.statisticTitle}`,
          admin: this.$store.state.AppActiveUser.admin_user,
          data: {
            before_datetime: this.beforeDate,
            after_datetime: this.afterDate,
            filename: this.fileName,
            format: this.selectedFormat,
            record_count: sum_data.length || 0,
            game_name: this.statisticTitle
          }
        }
        
        await axios.post('/agent/log', objectLogs)
      } catch (error) {
        console.error('Failed to log export action:', error)
      }
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    clearFields () {
      this.filename = this.statisticTitle
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    }
  }
}
</script>